export const readJsonApiResponse = async (response) => {
  const contentType = response.headers.get('content-type') || '';
  const text = await response.text();
  const endpoint = response.url || '/api/upload-json.php';

  if (!contentType.includes('application/json')) {
    throw new Error(
      `La API de guardado no responde con JSON (${endpoint}, HTTP ${response.status}). ` +
      'Verifica que la carpeta api este publicada junto a index.html y que el servidor ejecute PHP. No se pudo confirmar el guardado.'
    );
  }

  let result;
  try {
    result = JSON.parse(text);
  } catch {
    throw new Error('La API devolvio un JSON invalido. No se pudo confirmar el guardado; se conserva el contenido del editor.');
  }

  if (!response.ok || result?.success !== true) {
    throw new Error(result?.error || result?.message || `No se confirmo el guardado (HTTP ${response.status}).`);
  }

  return result;
};
